import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR
} from '../../themes'
const Style = styled.div`
  width: 100%;
  line-height: 24px;
  height: 52px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .badge-container {
    width: auto;
    height: 100%;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
    align-items: center;
    margin: 0 0 0 0;
    padding: 0 16px 0 0;
    line-height: 24px;
    border: 1px solid ${COLOR.GRAY_5};
    border-radius: 3px;
    font-size: ${FONT_SIZE.MN};
  }
  figure {
    height: ${FONT_SIZE.XL};
    width: ${FONT_SIZE.XL};
    margin: 16px 16px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid ${COLOR.GRAY_6};
  }
  figure > img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    color: ${COLOR.GRAY_6};
    fill: ${COLOR.GRAY_6};
  }
  .name-container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    flex: 1;
    height: auto;
  }
  h1.user-name {
    margin: 0;
    padding: 0;
    line-height: ${FONT_SIZE.XXS};
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.MN};
    color: ${COLOR.BLACK_1};
  }
  label.user-username {
    margin: 0;
    padding: 0;
    line-height: 1em;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.MMN}
  }
  button.close-button {
    margin: auto 0;
    padding: 0;
    width: ${FONT_SIZE.XL};
    height: ${FONT_SIZE.XL};
    background-color: transparent;
    border: none;
    border-radius: 50%;
    outline: none;
    color: ${COLOR.GRAY_6};
    cursor: pointer;
    transition: color 80ms ease-out, background-color 80ms ease-out;
  }
  button.close-button:hover {
    color: ${COLOR.BLACK_1};
  }
  button.close-button:focus {
    color: white;
    background-color: ${COLOR.GRAY_6};
  }
  button.close-button:active {
    color: white;
    background-color: ${COLOR.BLACK_1};
  }
  button.close-button > * {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 4px;
    box-sizing: border-box;
  }
  .jump-in {
  }
  @keyframes badge-jump-in {
    0% {
      height: 0%;
      width: 0%;
      top: 50%;
      left: 50%;
      opacity: 0;
    }
    100% {
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      opacity: 1;
    }
  }
`

export default Style
